import { AfterViewInit, Directive, HostListener, Renderer2, ViewContainerRef } from '@angular/core';

/**
 * Modify the styles of the twc-sidebar-items to get the correct layout.
 */
@Directive({
    selector: '[cwSidebarSubmenu]',
    standalone: false,
})
export class SidebarSubmenuDirective implements AfterViewInit {
    sidebar: HTMLElement | null = null;
    itemSelected: HTMLElement | null = null;
    itemSelectedSubmenu: HTMLElement | null = null;
    sidebarItems: NodeListOf<HTMLElement> | null = null;
    isSidebarOpen = false;
    constructor(
        private renderer: Renderer2,
        private viewContainer: ViewContainerRef
    ) {}

    ngAfterViewInit(): void {
        this.sidebar = this.viewContainer.element.nativeElement;
        this.sidebarItems = this.viewContainer.element.nativeElement.querySelectorAll('twc-sidebar-item') || null;

        this.removeTWCStyles();
    }

    @HostListener('click', ['$event.target'])
    onClick(target: HTMLElement): void {
        this.itemSelected = target.closest('twc-sidebar-item');
        this.itemSelectedSubmenu = this.itemSelected?.querySelector('twc-menu') || null;
        this.isSidebarOpen = this.sidebar?.classList.contains('twc-expanded') || false;

        this.toggleSubmenu();
    }

    removeTWCStyles(): void {
        this.sidebarItems?.forEach((item: HTMLElement) => {
            const submenu = item.querySelector('twc-menu');
            if (!submenu) {
                return;
            }
            this.renderer.removeClass(submenu, 'twc-invisible');
            this.renderer.removeAttribute(submenu, 'hidden');
            this.renderer.setStyle(submenu, 'visibility', 'hidden');
        });
    }

    closeMenu(item: HTMLElement): void {
        this.renderer.setStyle(item, 'visibility', 'hidden');

        if (item.style.left === '3.5rem') {
            setTimeout(() => {
                this.renderer.removeStyle(item, 'left');
            }, 300);
        }
    }

    openMenu(): void {
        this.renderer.setStyle(this.itemSelectedSubmenu, 'visibility', 'visible');
        this.renderer.setStyle(this.itemSelectedSubmenu, 'transition', 'visibility 0.2s ease');

        if (!this.isSidebarOpen) {
            this.renderer.setStyle(this.itemSelectedSubmenu, 'left', '3.5rem');
        }
    }

    getPreviousItemOpened(): HTMLElement | undefined {
        const submenuItems: NodeListOf<HTMLElement> | undefined = this.sidebar?.querySelectorAll('twc-menu');

        if (!submenuItems) {
            return undefined;
        }

        return Object.values(submenuItems).find((item: HTMLElement) => item.style.visibility === 'visible');
    }

    toggleSubmenu(): void {
        const submenuItemOpened = this.getPreviousItemOpened();

        if (!submenuItemOpened && this.itemSelectedSubmenu) {
            this.addStyles();
            this.openMenu();
            return;
        }

        if (submenuItemOpened) {
            this.closeMenu(submenuItemOpened);
            const itemOpened: HTMLElement = submenuItemOpened.closest('twc-sidebar-item') as HTMLElement;
            this.removeStyles(itemOpened);
        }
    }

    addItemSelectedStyle(): void {
        this.renderer.setStyle(this.itemSelected, 'background-color', 'var(--twc-light-gray)');
        this.renderer.setStyle(this.itemSelected, 'transition', '0.3s background-color ease');
    }

    removeItemSelectedStyle(item: HTMLElement): void {
        this.renderer.setStyle(item, 'background-color', 'transparent');
    }

    addStyleToClosedItems(): void {
        if (!this.sidebarItems || !this.sidebarItems.length) {
            return;
        }

        this.sidebarItems.forEach((sidebarItem: HTMLElement) => {
            if (sidebarItem === this.itemSelected) {
                return;
            }

            this.renderer.setStyle(sidebarItem, 'pointer-events', 'none');
        });
    }

    removeStyleToClosedItems(item: HTMLElement): void {
        if (!this.sidebarItems || !this.sidebarItems.length) {
            return;
        }

        this.sidebarItems.forEach((sidebarItem: HTMLElement) => {
            if (sidebarItem === item) {
                return;
            }
            this.renderer.removeStyle(sidebarItem, 'pointer-events');
        });
    }

    addStyles(): void {
        this.addItemSelectedStyle();
        this.addStyleToClosedItems();
    }

    removeStyles(item: HTMLElement): void {
        this.removeItemSelectedStyle(item);
        this.removeStyleToClosedItems(item);
    }
}
